import React, { forwardRef } from "react"
import { Link } from "../Router"
import { forceTrailingSlash } from "../../util/urlTransforms"

export default forwardRef((props, ref) => {
    let { url = undefined, rel = undefined, children } = props;

    if (url) {
        if (url.startsWith("http")) {
            return <a { ...props } href={ url } ref={ ref } rel={ rel }>{ children }</a>;
        }
        // add trailing slash to link so that we avoid a redirection for robots/crawlers that hit's the link directly
        url = forceTrailingSlash( url )
        return <Link to={ url } { ...props } ref={ ref } rel="preload">{ children }</Link>;
    }

    return <button { ...props } ref={ ref }>{ children } </button>;
});
